// 1. 외부 패키지


// 2. 프로젝트 내부 alias


// 3. 상대 경로
import Rt from "../rt";

// 4. 타입


export default function PriceInfo() {
	return (
		<div className='detail_bottom_wrap price_info'>
			<Rt.RtTableWrapper />
			<Rt.RtChartWrapper />
		</div>
	);
}